export const selectedUser = state => {
  return state.selectedUser
}

export const selectedGroup = state => {
  return state.selectedGroup
}
